import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface LanguageState {
  language: "ar" | "en"
}

// Get initial language from localStorage
const getInitialLanguage = (): "ar" | "en" => {
  const stored = localStorage.getItem('language') || localStorage.getItem('i18nextLng')
  return stored === 'en' ? 'en' : 'ar'
}

const initialState: LanguageState = {
  language: getInitialLanguage(),
}

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    changeLanguage: (state, action: PayloadAction<"ar" | "en">) => {
      state.language = action.payload
      
      // Save to localStorage immediately for API interceptor
      localStorage.setItem('language', action.payload)
      
      // Also save to i18nextLng for compatibility
      localStorage.setItem('i18nextLng', action.payload)
    },
  },
})

export const { changeLanguage } = languageSlice.actions
export const selectLanguage = (state: { language: LanguageState }) => state.language.language
export default languageSlice.reducer
